module.exports = __webpack_public_path__ + "img/icon6.9197a9af.png";